import React, { Component, Fragment } from "react"
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import "../../i18n"
import moment from 'moment'
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'
import "./main_container.scss"
import Coupon from "./coupon"
import SearchForm from "./search_form"
import lozad from 'lozad'

export class Main extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isShowCode: false
    }

    moment.locale(languageHelper.pageLocale)
  }

  async componentDidMount() {
    delete this._query
    const observer = lozad()
    observer.observe()
  }

  handleClick = () => {
    this.setState({ isShowCode: true })
  }

  render() {
    return (
      <Fragment>
        <section styleName="cover">
          <div className="lozad" styleName="content" data-background-image="/assets/image/features/longstay/bg-pattern.svg">
            <div>
              <h1>
                <span styleName="first">一時帰国や自主隔離、テレワークにおすすめの</span><br />
                <span styleName="second">
                  <span>長期滞在向け</span>
                  <span>宿泊・民泊施設</span>
                </span>
              </h1>
            </div>
          </div>
        </section>
        <section styleName="feature">
          <div styleName="content">
            <h2>Rakuten Oyadoで長期滞在に人気</h2>
            <span styleName="property-type">アパートメント/マンション</span>
            <span styleName="property-type">一戸建てタイプ（一軒家）</span>
            <h2>快適・便利に過ごせる充実の設備</h2>
            <div styleName="icon-group">
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/laundry_32.svg" alt="" />
                </div>
                <div styleName="label">洗濯機<br/>乾燥機</div>
              </div>
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/kitchen_32.svg" alt="" />
                </div>
                <div styleName="label">キッチン</div>
              </div>
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/refregirator_32.svg" alt="" />
                </div>
                <div styleName="label">冷蔵庫</div>
              </div>
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/chin_32.svg" alt="" />
                </div>
                <div styleName="label">電子レンジ</div>
              </div>
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/desk_32.svg" alt="" />
                </div>
                <div styleName="label">机<br/>ワークスペース</div>
              </div>
              <div styleName="icon">
                <div styleName="img-container">
                  <img src="/assets/image/features/longstay/wifi_32.svg" alt="" />
                </div>
                <div styleName="label">Wi-Fi</div>
              </div>
            </div>
            <div styleName="note">※ 検索後に条件の追加および変更も可能です</div>
          </div>
          <div styleName="image-container">
            <img className="lozad" styleName="image" data-src="/assets/image/features/longstay/img-1.jpg" />
            <img className="lozad" styleName="image" data-src="/assets/image/features/longstay/img-2.jpg" />
            <img className="lozad" styleName="image" data-src="/assets/image/features/longstay/img-3.jpg" />
          </div>
        </section>
        <div styleName="search">
          <div className="lozad" styleName="content" data-background-image="/assets/image/features/longstay/bg-pattern.svg">
            <div styleName="container">
              <h2>
                <span>ご希望のエリアを選んで</span><br/>
                <span>長期滞在向けの宿泊・民泊施設を<br/>今すぐ検索！</span>
              </h2>
              <SearchForm />
              <Coupon
                id="btn-show-coupon-code-top"
                isShowCode={this.state.isShowCode}
                handleClick={this.handleClick} />
            </div>
          </div>
        </div>
        <div styleName="container">
          <section>
            <h2>長期滞在におすすめの宿泊施設とは？</h2>
            <p>長期滞在でまず注意したいのが着替えです。滞在期間が一週間以上のような場合にすべての日数分の着替えを持ち込もうとするとかなりの量になります。特に一時帰国のような場合だとさらに難しくなることでしょう。そこでおすすめなのが「洗濯機」付きの宿泊施設です。乾燥機能付きのドラム型を設置している宿泊施設もあるのでとても便利に使えます。また、事前に洗濯ができることがわかるので持ち込む衣類の量をコントロールしやすいのもメリットです。</p>
            <p>そして、もう一つ重要なポイントが「食事」です。一週間や二週間の間毎日外食するという方は少ないでしょう。特に隔離生活をせざるを得ない状況の場合はなおさらです。そこであると助かるのが「キッチン」です。基本的な調理器具や食器も使えることがほとんどなので、食材を持ち込めば長期の滞在でも外出せずに食事をすることができます。</p>
            <p>Rakuten Oyadoでの5泊以上の長期滞在では「洗濯機」および「キッチン」の付いた宿泊施設が短期の宿泊に比べて約1.4倍選ばれています。</p>
          </section>
          <section>
            <h2>Rakuten Oyadoなら見つかる</h2>
            <p>Rakuten Oyadoには長期滞在に特に人気のアパートメントタイプの宿泊施設や広々使える一棟丸っと貸切の一軒家・戸建てタイプの宿泊施設が多数登録されており、これらの宿泊施設の多くには洗濯機、キッチン、その他電子レンジや電気ポットなど長期滞在に便利な設備、備品が備わっています。まずは、気になるエリアにどのような宿泊施設があるのかチェックしてみてください。</p>
            <div styleName="img-living" className="lozad" data-background-image="/assets/image/features/longstay/living.jpg"></div>
          </section>
          <section styleName="monthly-banner">
            <h2>１か月以上の滞在をご検討中ですか？</h2>
            <p>１か月から数か月の滞在をお考えの方は「LIFULL HOME’S マンスリー」もおすすめ。出張、転勤、研修、就活、受験、仮住まいなどに便利なマンスリーマンション・短期賃貸物件を沿線・駅・地域から検索して、まとめてお問い合わせができます！</p>
            <a id="monthly-banner" href="https://monthly.homes.jp" target="_blank" rel="noopener noreferrer">
              <img className="lozad" src="" data-src="/assets/image/features/longstay/monthly-banner-pc.jpg" alt="LIFULL HOME'S Monthly" />
            </a>
          </section>
        </div>
        <Modal />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state.search,
    propertyTypes: state.propertyTypes
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
